import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogOverlay,
    DialogPortal,
    DialogTitle,
} from "@radix-ui/react-dialog";
import * as React from "react";
import { Button } from "./Button";

const AlertDialogDemo = ({
    id,
    open,
    setOpen,
    handleDelete,
}: {
    id: number | null;
    open: boolean;
    setOpen: React.Dispatch<
        React.SetStateAction<{
            id: number | null;
            isOpen: boolean;
        }>
    >;
    handleDelete: (id: number) => Promise<void>;
}) => (
    <Dialog open={open} onOpenChange={() => setOpen({ id: null, isOpen: false })}>
        <DialogPortal>
            <DialogOverlay className="data-[state=open]:animate-overlayShow fixed inset-0 z-40 bg-gray-100/75" />
            <DialogContent className="data-[state=open]:animate-contentShow fixed left-1/2 top-1/2 z-50 max-h-[85vh] w-[90vw] max-w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-md bg-white p-[25px] shadow-[var(--shadow-6)] focus:outline-none">
                <DialogTitle className="text-mauve12 m-0 text-[17px] font-medium">
                    Are you sure?
                </DialogTitle>
                <DialogDescription className="text-mauve11 mb-5 mt-2.5 text-[15px] leading-normal">
                    This action cannot be undone. This will permanently delete your vendor.
                </DialogDescription>
                <div style={{ display: "flex", gap: 25, justifyContent: "flex-end" }}>
                    <Button
                        className="outline-none"
                        type="button"
                        onClick={() => setOpen({ id: null, isOpen: false })}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="bg-red-600 hover:bg-red-700"
                        type="button"
                        onClick={() => id && handleDelete(id)}
                    >
                        Delete
                    </Button>
                </div>
            </DialogContent>
        </DialogPortal>
    </Dialog>
);

export default AlertDialogDemo;
